module.exports = __webpack_public_path__ + "static/img/ad1-1.0f8d2ea.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/spark40/ad1-1.png
// module id = EEwX
// module chunks = 12